import * as React from "react";

import { Box, makeStyles, Theme, Typography } from "@material-ui/core";

import { useBranding } from "client/hooks";
import { useNormalizedBrandPaletteValues } from "client/hooks/useNormalizedBrandThemeValues";

const useStyles = makeStyles((theme: Theme) => {
  const { gray10 } = useNormalizedBrandPaletteValues(theme);

  return {
    root: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-end",
      paddingRight: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    yesNoLabel: {
      color: gray10,
      fontWeight: theme.typography.fontWeightBold,
      "&:first-of-type": {
        marginRight: theme.spacing(3.5),
      },
    },
  };
});

export const YesOrNoQuestionsHeader: React.FC = () => {
  const { brandKey } = useBranding();
  const isCash = brandKey === "CashApp";

  const classes = useStyles();
  return isCash ? (
    <></>
  ) : (
    <Box className={classes.root}>
      <Typography className={classes.yesNoLabel}>Yes</Typography>
      <Typography className={classes.yesNoLabel}>No</Typography>
    </Box>
  );
};
